import { render } from "./PatientSearch.vue?vue&type=template&id=b5e3f504&ts=true"
import script from "./PatientSearch.vue?vue&type=script&lang=ts"
export * from "./PatientSearch.vue?vue&type=script&lang=ts"

import "./PatientSearch.vue?vue&type=style&index=0&id=b5e3f504&lang=css"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__